
import { defineComponent } from 'vue';
import AppContent from '../bases/AppContent.vue';
import Button from '../bases/Button.vue';
import '../assets/main.css';
import { useRouter } from 'vue-router';

export default defineComponent({
  components: { AppContent, Button },
  setup() {
    const router = useRouter();

    const toApp = () => {
      router.push('/inputUrl');
    };
    const toTemplateSite = () => {
      window.open('https://template.kodomo-suite.jp/', '_blank');
    };
    return {
      toTemplateSite,
      toApp,
    };
  },
});
